export function buyerAdvisoryVacantLandKWSW() {
return [   // Release 2026-01-09 10:09:57
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 166.6,
   left: 166.8,
   width: 383.88,
   height: 16.287
}
,
{
   page: 0,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 193.6,
   left: 166.68,
   width: 378.12,
   height: 16.287
}
,
{
   page: 6,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 318.453,
   left: 52.0909,
   width: 171.1201,
   height: 14.869
}
,
{
   page: 6,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 315.638,
   left: 225.251,
   width: 76.046,
   height: 18.128
}
] }
